'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

var _messageBusEventError = require('../errors/message-bus-event-error');

var _messageBusEventError2 = _interopRequireDefault(_messageBusEventError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function validate() {
    var _this = this;

    var mandatoryEventProperties = ['eventName', 'eventVersion', 'namespace', 'eventType', 'eventSource'];
    var missingEventProperties = [];
    mandatoryEventProperties.forEach(function (mandatoryEvent) {
        if (!Object.keys(_this).includes(mandatoryEvent) || _this[mandatoryEvent] === null || _this[mandatoryEvent] === undefined) {
            missingEventProperties.push(mandatoryEvent);
        }
    });
    if (missingEventProperties.length === 0) {
        return;
    }
    throw new _messageBusEventError2.default('Cannot build MessageBusEvent without: ' + missingEventProperties);
}

/**
 * An extensible object for creating Message Bus Events. Fragments and specific event objects can extend from this class
 * and set event properties defined here. The specific event objects can leverage the builder pattern here and add specific properties.
 * PLEASE NOTE: The build function must be called in order to include mandatory event properties like eventId and eventTime.
 */

var MessageBusEvent = function () {
    function MessageBusEvent() {
        _classCallCheck(this, MessageBusEvent);
    }

    _createClass(MessageBusEvent, [{
        key: 'withEventName',

        /**
         * Sets the event name.
         * @param {String} eventName -  The name of the event.
         * @returns an instance of MessageBusEvent with the set event name.
         */
        value: function withEventName(eventName) {
            this.eventName = eventName;
            return this;
        }

        /**
         * Sets the event version.
         * @param {String} eventVersion - The version of the event.
         * @returns an instance of MessageBusEvent with the set event version.
         */

    }, {
        key: 'withEventVersion',
        value: function withEventVersion(eventVersion) {
            this.eventVersion = eventVersion;
            return this;
        }

        /**
         * Sets the event type.
         * @param {String} eventType  - The event type.
         * @returns an instance of MessageBusEvent with the set event type.
         */

    }, {
        key: 'withEventType',
        value: function withEventType(eventType) {
            this.eventType = eventType;
            return this;
        }

        /**
         * Sets the event namespace
         * @param {String} namespace - The namespace of the event.
         * @returns an instance of MessageBusEvent with the set event namespace.
         */

    }, {
        key: 'withNamespace',
        value: function withNamespace(namespace) {
            this.namespace = namespace;
            return this;
        }

        /**
         * Sets the event source
         * @param {String} eventSource - The source of the event.
         * @returns an instance of MessageBusEvent with the set event source.
         */

    }, {
        key: 'withEventSource',
        value: function withEventSource(eventSource) {
            this.eventSource = eventSource;
            return this;
        }

        /**
         * Builds the event object with all set properties. Validates whether mandatory properties like eventName, eventSource, eventType etc
         * have been set. All events that extend this class MUST call build function to set raw event properties.
         * @throws {MessageBusEventError} if mandatory properties for event have not been set.
         * @returns {Object} an immutable object representing a raw Message Bus Event.
         */

    }, {
        key: 'build',
        value: function build() {
            validate.bind(this)();
            return Object.freeze({
                eventId: _uuid2.default.v4(),
                eventName: this.eventName,
                eventVersion: this.eventVersion,
                eventTime: '' + Date.now(),
                eventType: this.eventType,
                namespace: this.namespace,
                eventSource: this.eventSource
            });
        }
    }]);

    return MessageBusEvent;
}();

exports.default = MessageBusEvent;